import React, { useContext } from 'react';
import { Box } from '@mui/system';
import { AccessDataContext } from '../contextProviders/AccessDataContext';

import LoggedInRoutes from '../routes/LoggedInRoutes';
import LoggedOutRoutes from '../routes/LoggedOutRoutes';
import { OverlayContext } from '../contextProviders/OverlayContext';

function SiteContent() {
  const { user } = useContext(AccessDataContext);
  const { loadingOverlay } = useContext(OverlayContext);

  return (
    <Box>
      {loadingOverlay()}
      {user ? <LoggedInRoutes /> : <LoggedOutRoutes />}
    </Box>
  );
}

export default SiteContent;
